export enum AimeeState {
    MONITORED = 'monitored',
    UNKNOWN = 'unknown',
    MERGED = 'merged',
    ARCHIVED = 'archived',
}

export enum BlockStatus {
    UNDECIDED = 'undecided',
    BLOCKED = 'blocked',
    TRUSTED = 'trusted',
}

export enum assetNetworkType {
    NetworkTypeOT = 'ot',
    NetworkTypeCrew = 'crew',
    NetworkTypeBusiness = 'business',
    NetworkTypeOther = 'other',
}
